"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var React = __importStar(require("react"));

var Icon_1 = __importDefault(require("../Icon"));

var Loader_1 = __importDefault(require("../Loader"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var customDarken = function customDarken(amount, color) {
  if (color === 'transparent') {
    return "rgba(0, 0, 0, " + amount + ")";
  }

  return polished_1.darken(amount, color);
};

var Wrapper = styled_components_1.default('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  position: relative;\n  cursor: ", ";\n  display: inline-flex;\n  width: ", ";\n  align-items: center;\n  justify-content: center;\n  min-height: ", ";\n  outline: 0;\n  border: none;\n  background: ", ";\n  color: ", ";\n  vertical-align: baseline;\n  padding: 0 ", ";\n  ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: 500;\n  line-height: 1em;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  border-radius: ", ";\n  border: ", " solid ", ";\n  user-select: none;\n  font-family: ", ";\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,\n    box-shadow 0.1s ease, background 0.1s ease;\n  ", ";\n"], ["\n  margin: 0;\n  position: relative;\n  cursor: ", ";\n  display: inline-flex;\n  width: ", ";\n  align-items: center;\n  justify-content: center;\n  min-height: ", ";\n  outline: 0;\n  border: none;\n  background: ", ";\n  color: ", ";\n  vertical-align: baseline;\n  padding: 0 ", ";\n  ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: 500;\n  line-height: 1em;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  border-radius: ", ";\n  border: ", " solid ", ";\n  user-select: none;\n  font-family: ", ";\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,\n    box-shadow 0.1s ease, background 0.1s ease;\n  ", ";\n"])), function (_a) {
  var disabled = _a.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_a) {
  var block = _a.block;
  return block ? '100%' : 'auto';
}, polished_1.rem(38), function (_a) {
  var theme = _a.theme;
  return theme.buttonBackgroundColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.buttonTextColor;
}, polished_1.rem(22), function (_a) {
  var withoutContent = _a.withoutContent,
      icon = _a.icon;
  return withoutContent && icon && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 0 ", ";\n    "], ["\n      padding: 0 ", ";\n    "])), polished_1.rem(12));
}, polished_1.rem(14), function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.buttonBorderColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, function (_a) {
  var disabled = _a.disabled,
      theme = _a.theme;
  return disabled ? '' : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          &:hover {\n            background: ", ";\n          }\n          &:focus {\n            background: ", ";\n          }\n          &:active {\n            background: ", ";\n          }\n        "], ["\n          &:hover {\n            background: ", ";\n          }\n          &:focus {\n            background: ", ";\n          }\n          &:active {\n            background: ", ";\n          }\n        "])), customDarken(0.05, theme.buttonBackgroundColor), customDarken(0.1, theme.buttonBackgroundColor), customDarken(0.2, theme.buttonBackgroundColor));
});
var StyledIcon = styled_components_1.default(Icon_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var noMargin = _a.noMargin;
  return !noMargin && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), polished_1.rem(9));
});
var StyledLoader = styled_components_1.default(Loader_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transition: transform 0.2s, opacity 0.2s;\n  transform-origin: left top;\n  ", ";\n"], ["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transition: transform 0.2s, opacity 0.2s;\n  transform-origin: left top;\n  ", ";\n"])), function (_a) {
  var loading = _a.loading;

  if (loading) {
    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        opacity: 1;\n        transform: scale(1) translate(-50%, -50%);\n      "], ["\n        opacity: 1;\n        transform: scale(1) translate(-50%, -50%);\n      "])));
  }

  return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      opacity: 0;\n      transform: scale(0) translate(-50%, -50%);\n    "], ["\n      opacity: 0;\n      transform: scale(0) translate(-50%, -50%);\n    "])));
});
var Content = styled_components_1.default('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  transition: opacity 0.2s;\n  opacity: ", ";\n  display: flex;\n  align-items: center;\n"], ["\n  transition: opacity 0.2s;\n  opacity: ", ";\n  display: flex;\n  align-items: center;\n"])), function (_a) {
  var isLoading = _a.isLoading;
  return isLoading ? 0.25 : 1;
});

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Button.prototype.render = function () {
    var _a = this.props,
        theme = _a.theme,
        primary = _a.primary,
        danger = _a.danger,
        success = _a.success,
        warning = _a.warning,
        block = _a.block,
        basic = _a.basic,
        loading = _a.loading,
        disabled = _a.disabled,
        _onClick = _a.onClick,
        icon = _a.icon,
        type = _a.type,
        className = _a.className,
        children = _a.children,
        restProps = __rest(_a, ["theme", "primary", "danger", "success", "warning", "block", "basic", "loading", "disabled", "onClick", "icon", "type", "className", "children"]);

    var buttonTheme = {
      buttonBackgroundColor: 'transparent',
      buttonTextColor: theme.textColor
    }; // basic states

    if (primary) {
      if (basic) {
        buttonTheme = __assign({}, buttonTheme, {
          buttonTextColor: theme.color.primary
        });
      } else {
        buttonTheme = __assign({}, buttonTheme, {
          buttonBackgroundColor: theme.color.primary,
          buttonTextColor: '#fff'
        });
      }
    } else if (danger) {
      if (basic) {
        buttonTheme = __assign({}, buttonTheme, {
          buttonTextColor: theme.color.danger
        });
      } else {
        buttonTheme = __assign({}, buttonTheme, {
          buttonBackgroundColor: theme.color.danger,
          buttonTextColor: '#fff'
        });
      }
    } else if (success) {
      if (basic) {
        buttonTheme = __assign({}, buttonTheme, {
          buttonTextColor: theme.color.success
        });
      } else {
        buttonTheme = __assign({}, buttonTheme, {
          buttonBackgroundColor: theme.color.success,
          buttonTextColor: '#fff'
        });
      }
    } else if (warning) {
      if (basic) {
        buttonTheme = __assign({}, buttonTheme, {
          buttonTextColor: theme.color.warning
        });
      } else {
        buttonTheme = __assign({}, buttonTheme, {
          buttonBackgroundColor: theme.color.warning,
          buttonTextColor: '#fff'
        });
      }
    }

    if (disabled) {
      if (basic) {
        buttonTheme = __assign({}, buttonTheme, {
          buttonTextColor: theme.inactiveColor
        });
      } else {
        buttonTheme = __assign({}, buttonTheme, {
          buttonBackgroundColor: theme.inactiveColor,
          buttonTextColor: '#fff'
        });
      }
    } // nastavime spravny border


    if (basic) {
      buttonTheme = __assign({}, buttonTheme, {
        buttonBorderColor: buttonTheme.buttonTextColor
      });
    } else {
      buttonTheme = __assign({}, buttonTheme, {
        buttonBorderColor: buttonTheme.buttonBackgroundColor
      });
    }

    return React.createElement(styled_components_1.ThemeProvider, {
      theme: buttonTheme
    }, React.createElement(Wrapper, __assign({
      className: "sportnetui-btn " + className,
      block: block,
      disabled: disabled,
      icon: icon,
      withoutContent: !children,
      type: type,
      onClick: function onClick(e) {
        if (!disabled && _onClick) {
          _onClick(e);
        }
      }
    }, restProps), React.createElement(Content, {
      isLoading: loading
    }, icon && React.createElement(StyledIcon, {
      noMargin: !children,
      size: "l",
      name: icon,
      color: buttonTheme.buttonTextColor
    }), children), React.createElement(StyledLoader, {
      size: "l",
      loading: loading,
      color: buttonTheme.buttonTextColor
    })));
  };

  Button.defaultProps = {
    className: '',
    children: null,
    primary: false,
    danger: false,
    success: false,
    warning: false,
    block: false,
    basic: false,
    loading: false,
    disabled: false,
    type: 'submit',
    onClick: function onClick() {}
  };
  return Button;
}(React.PureComponent);

exports.default = styled_components_1.withTheme(Button);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;